import type { FaireProductEntity } from "../../entity_types/product";

export const p_6uh8cafjei: FaireProductEntity = {
  token: "p_6uh8cafjei",
  type: "product",
  name: "Beachwood — Organic Certified",
  brandToken: "b_50b0t2xt",
  brandName: "Canyon Coffee",
  imageUrl:
    "https://cdn.faire.com/fastly/58c008cd95c0b220286fadf62bdd7743b14024baa9685b8d76d41bd9ce0c5e7b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/879c3150333cde43d68a9b5139c833a4c8223535a427c11126312f9778ffac4c.jpeg",
    "https://cdn.faire.com/fastly/083b51a54b37a4343e7964aa10555dcc7d842854ff260f7254eb63a7d7df9257.jpeg",
  ],
  priceDollars: 12.1,
  description:
    "Beachwood will always champion the style of cup we sought to create when starting Canyon—smooth, balanced, and caramelly. A coffee that's easy to brew at home and hits the spot, every morning. We rotate the origin seasonally, to showcase the coffee at its best.\n\n• Origin: Mexico\n• Region: San Agustín Loxicha, indigenous Zapotec community in the state of Oaxaca\n• Producer: UNECAFE S.C\n• Process: Washed\n• Certification: Organic\n• We Taste: Caramel, milk chocolate, & orange peel\n\n𝐄𝐱𝐩𝐞𝐫𝐢𝐞𝐧𝐜𝐞\nBeachwood holds a lot of meaning to us. The name comes from Beachwood Canyon in Los Angeles, the canyon where we—Ally and Casey—met back in 2013.\n\nOur goal is for Beachwood to be a showcase for fresh, seasonal coffees that we can talk about through story. This coffee is also our go-to for espresso, and we roast it with ample development time for ease of extraction and an espresso that tastes great black.",
  tags: [],
  msrpDollars: 24.2,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-12T22:02:06.256Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
